import React, { useState } from "react";
import styled from "styled-components";
import { Icon } from "components/common";
import { Row, Col } from "common/components";
import { MarkdownPreview } from "components/common/MarkdownEditor";
const CollapsibleTrigger = styled(Icon)`
  cursor: pointer;
`;
const CollapsibleBody = styled.div`
  max-height: ${({ $isExpanded }) => $isExpanded ? "400px" : "0"};
  overflow: hidden;
  position: relative;
  width: 100%;
  padding: 0 ${({ theme }) => theme.spacings.md};
  transition: max-height 0.3s ease;
`;
function Description({ title, description, isOpen = false }) {
  const [isExpanded, setIsExpanded] = useState(isOpen);
  if (!description) return null;
  const toggleExpanded = () => setIsExpanded((prev) => !prev);
  return /* @__PURE__ */ React.createElement(Col, { $gap: 0 }, /* @__PURE__ */ React.createElement(Row, { $align: "center" }, /* @__PURE__ */ React.createElement(CollapsibleTrigger, { name: isExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down", onClick: toggleExpanded }), /* @__PURE__ */ React.createElement("strong", null, title)), /* @__PURE__ */ React.createElement(CollapsibleBody, { $isExpanded: isExpanded }, /* @__PURE__ */ React.createElement(MarkdownPreview, { show: true, maxHeight: 500, noBackground: true, noBorder: true, value: description, noPadding: true })));
}
export default Description;
